{
  "familyId": "MET-SCHAAL-BASIS",
  "questions": [
    {
      "id": "MET-SCHAAL-BASIS-001",
      "familyId": "MET-SCHAAL-BASIS",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_basis",
      "questionType": "multiple_choice",
      "question": "Op een plattegrond staat schaal 1:100. Een kamer is op de tekening 5 cm lang. Hoe lang is de kamer in het echt?",
      "options": ["5 m", "50 m", "500 m", "0,5 m"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Schaal 1:100",
            "content": "Schaal 1:100 betekent: 1 cm op de tekening = 100 cm in het echt. Dus 5 cm op de tekening = 5 × 100 = 500 cm = 5 meter.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schaal_basis_berekenen",
      "variantIndex": 1,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Schaal 1:100 betekent: 1 cm op de tekening = 100 cm in het echt. De kamer is 5 cm op de tekening, dus 5 × 100 = 500 cm = 5 meter. Onthoud: van tekening naar echt = vermenigvuldigen met het schaalgetal.",
        "solutionSteps": [
          "Schaal 1:100 → 1 cm = 100 cm in het echt",
          "5 cm × 100 = 500 cm",
          "500 cm = 5 m ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 5 cm × 100 = 500 cm = 5 meter.",
          "1": "Je dacht waarschijnlijk dat 5 × 100 = 500 en dat het antwoord 50 m is. Maar 5 × 100 = 500 cm, en 500 cm = 5 m, niet 50 m. Onthoud: reken altijd om naar de juiste eenheid.",
          "2": "Je dacht waarschijnlijk dat het antwoord 500 m is. Maar 5 × 100 = 500 cm, niet 500 m. Onthoud: de schaal werkt in dezelfde eenheid — cm × 100 = cm.",
          "3": "Je dacht waarschijnlijk dat je 5 ÷ 100 moest doen. Maar bij schaal vermenigvuldig je de tekening-maat met het schaalgetal. Onthoud: van tekening naar echt = vermenigvuldigen."
        }
      }
    },
    {
      "id": "MET-SCHAAL-BASIS-002",
      "familyId": "MET-SCHAAL-BASIS",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_basis",
      "questionType": "multiple_choice",
      "question": "Een tuin is in het echt 12 meter lang. Op een tekening met schaal 1:200 is de tuin dan:",
      "options": ["12 cm", "60 cm", "6 cm", "24 cm"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van echt naar tekening",
            "content": "Van echt naar tekening: deel door het schaalgetal. 12 m = 1200 cm. 1200 ÷ 200 = 6 cm op de tekening.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schaal_echt_naar_tekening",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Van echt naar tekening: deel door het schaalgetal. Eerst omrekenen: 12 m = 1200 cm. Dan delen: 1200 ÷ 200 = 6 cm op de tekening. Onthoud: echt → tekening = delen, en reken altijd eerst om naar cm.",
        "solutionSteps": [
          "Reken om naar cm: 12 m = 1200 cm",
          "Van echt naar tekening: delen door schaalgetal",
          "1200 ÷ 200 = 6 cm ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je alleen door 100 moest delen. Maar de schaal is 1:200, niet 1:100. 1200 ÷ 200 = 6 cm. Onthoud: gebruik altijd het juiste schaalgetal.",
          "1": "Je dacht waarschijnlijk dat 12 m = 120 cm. Maar 1 m = 100 cm, dus 12 m = 1200 cm. 1200 ÷ 200 = 6 cm, niet 60 cm. Onthoud: 1 meter = 100 centimeter.",
          "2": "Goed! 12 m = 1200 cm, gedeeld door 200 = 6 cm.",
          "3": "Je dacht waarschijnlijk dat je 12 × 200 moest doen. Maar van echt naar tekening moet je delen, niet vermenigvuldigen. Onthoud: echt → tekening = delen, tekening → echt = vermenigvuldigen."
        }
      }
    },
    {
      "id": "MET-SCHAAL-BASIS-003",
      "familyId": "MET-SCHAAL-BASIS",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_basis",
      "questionType": "multiple_choice",
      "question": "Wat betekent schaal 1:50?",
      "options": [
        "1 cm op de tekening = 50 m in het echt",
        "1 cm op de tekening = 50 cm in het echt",
        "50 cm op de tekening = 1 cm in het echt",
        "De tekening is 50 keer groter dan het echt"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Schaal lezen",
            "content": "Schaal 1:50 lees je als: '1 op de tekening is 50 in het echt'. De eenheid blijft hetzelfde. Dus 1 cm = 50 cm, of 1 mm = 50 mm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schaal_betekenis",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Schaal 1:50 betekent: 1 cm op de tekening = 50 cm in het echt. De eenheid blijft hetzelfde. De tekening is 50 keer kleiner dan de werkelijkheid. Onthoud: het eerste getal is de tekening, het tweede is de werkelijkheid — en de eenheid verandert niet.",
        "solutionSteps": [
          "Schaal 1:50 → 1 eenheid op tekening = 50 eenheden in echt",
          "Dus 1 cm = 50 cm in het echt",
          "De tekening is 50× kleiner dan de werkelijkheid ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de eenheid verandert. Maar bij schaal blijft de eenheid hetzelfde: cm blijft cm. 1 cm = 50 cm, niet 50 m. Onthoud: de eenheid verandert niet bij schaal.",
          "1": "Goed! 1 cm op de tekening = 50 cm in het echt.",
          "2": "Je dacht waarschijnlijk dat het andersom is. Maar 1:50 betekent dat de tekening kleiner is: 1 cm op tekening = 50 cm echt. Onthoud: het eerste getal is de tekening, het tweede is de werkelijkheid.",
          "3": "Je dacht waarschijnlijk dat de tekening groter is. Maar bij schaal 1:50 is de tekening 50 keer kleiner. Onthoud: als het tweede getal groter is, is de tekening kleiner dan het echt."
        }
      }
    },
    {
      "id": "MET-SCHAAL-BASIS-004",
      "familyId": "MET-SCHAAL-BASIS",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_basis",
      "questionType": "multiple_choice",
      "question": "Een architect tekent een huis met schaal 1:50. De voordeur is in het echt 2 meter hoog. Hoe hoog is de deur op de tekening?",
      "options": ["40 cm", "2 cm", "10 cm", "4 cm"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van echt naar tekening",
            "content": "Van echt naar tekening: deel door het schaalgetal. 2 m = 200 cm. 200 ÷ 50 = 4 cm op de tekening.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schaal_context_architect",
      "variantIndex": 4,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "2 m = 200 cm. Van echt naar tekening: 200 ÷ 50 = 4 cm. De deur is 4 cm hoog op de tekening. Onthoud: reken altijd eerst om naar centimeter, dan delen door het schaalgetal.",
        "solutionSteps": [
          "Reken om: 2 m = 200 cm",
          "Van echt naar tekening: delen door schaalgetal",
          "200 ÷ 50 = 4 cm ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je 2 m × 200 moest doen. Maar van echt naar tekening moet je delen, niet vermenigvuldigen. Onthoud: echt → tekening = delen.",
          "1": "Je dacht waarschijnlijk dat 2 m ÷ 50 = 2 cm. Maar je moet eerst omrekenen naar cm: 2 m = 200 cm. Dan 200 ÷ 50 = 4 cm. Onthoud: reken altijd eerst om naar dezelfde eenheid.",
          "2": "Je dacht waarschijnlijk dat je 200 ÷ 20 moest doen. Maar de schaal is 1:50, dus je deelt door 50. 200 ÷ 50 = 4 cm. Onthoud: gebruik het juiste schaalgetal.",
          "3": "Goed! 200 cm ÷ 50 = 4 cm op de tekening."
        }
      }
    },
    {
      "id": "MET-SCHAAL-BASIS-005",
      "familyId": "MET-SCHAAL-BASIS",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_basis",
      "questionType": "fill_in",
      "question": "Op een plattegrond met schaal 1:500 is een voetbalveld 20 cm lang. Hoe lang is het veld in het echt? Geef je antwoord in meters.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["100", "100 m", "100 meter"],
        "caseSensitive": false,
        "placeholder": "? meter"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van tekening naar echt",
            "content": "Van tekening naar echt: vermenigvuldig met het schaalgetal. 20 cm × 500 = 10.000 cm = 100 meter.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schaal_fill_in",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Van tekening naar echt: vermenigvuldig met het schaalgetal. 20 cm × 500 = 10.000 cm. Reken om naar meter: 10.000 cm ÷ 100 = 100 m. Het voetbalveld is 100 meter lang in het echt. Onthoud: tekening → echt = vermenigvuldigen, en vergeet niet om te rekenen naar de gevraagde eenheid.",
        "solutionSteps": [
          "Van tekening naar echt: vermenigvuldigen",
          "20 cm × 500 = 10.000 cm",
          "10.000 cm ÷ 100 = 100 m ✓"
        ]
      }
    }
  ]
}